<template>
		<v-col class="ma-0 pa-0">
			<v-row class="ma-0 pa-0 d-flex justify-center align-center">
				<span class="text-datas-number" :class="{'status-small': exibeSmall}" >
		      {{ genero | formataGen }}:
		    </span>
				<div>
				<span class="text-datas-number ml-1" :class="{'font-size-08': exibeSmall}">
				{{ qtAlocadosTotal }}
				</span>
				<span class="text-datas-extenso ml-1 mr-1" :class="{'font-size-08': exibeSmall}">de</span>
				<span class="text-datas-number" :class="{'font-size-08': exibeSmall}">
					{{ qtDisponivelTotal }}
				</span>
				</div>
			</v-row>
			<v-row class="ma-0 pa-0 d-flex justify-center" :class="{
				'sobrando--text': sobraTotal < 0,
				'status-small': exibeSmall && sobraTotal === 0
			}">
				<span :class="{'font-size-08': exibeSmall}">
					{{ statusQuantidade }}
				</span>
				<v-icon v-if="sobraTotal === 0" small :x-small="exibeSmall" color="success">
					mdi-check-circle
				</v-icon>
				<span :class="{'font-size-08': exibeSmall}">
					{{ sobraTotal | formataSobra }}
				</span>
			</v-row>
		</v-col>
</template>
<script>
import {mapState} from "vuex";

export default {
	name: 'saldo-alocado-dia',
	props: {
		dia: Number,
		lotesCrecheDia: {
			type: Array,
			required: true
		},
		crechario: {
			type: Object,
			required: true,
		},
		genero: {
			type: String,
			required: true,
		},
		nrDias: Number,
	},
	computed: {
		...mapState("planejamentoAlojamento", ["listaLotesAlocados"]),
		qtAlocadosTotal() {
				if (this.listaLotesAlocados.length === 0 || this.lotesCrecheDia.length === 0) return 0

				return this.lotesCrecheDia.map(lote => parseInt(lote[`qt${this.genero}Alocados`] || 0))
						.reduce((acc, lote) => acc + lote)
		},
		qtDisponivelTotal() {
			return parseInt(this.crechario[`qt${this.genero}Dia${this.dia}`] || 0)
		},
		sobraTotal() {
			return this.qtDisponivelTotal - this.qtAlocadosTotal
		},
		statusQuantidade(){
			if (this.sobraTotal === 0) return 'Demanda completa'
			return this.sobraTotal > 0 ? 'Faltando' : 'Sobrando'
		},
		exibeSmall() {
			return this.nrDias > 4
		},
	},
	filters: {
		formataGen(val) {
			return val === 'Femeas' ? 'Fêmeas' : 'Machos'
		},
		formataSobra(val) {
			if(val === 0) return ''
			return Math.abs(val)
		}
	},
}
</script>

<style scoped lang="scss">
.sobrando--text {
  color: #CC0000;
}

.status-small{
	font-size: 12px;
}
</style>